/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_ProjectsInputs */

const en_mk_mx_projects = /** @type {(inputs: Mk_Mx_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects, sub-issues, dependencies`)
};

const id_mk_mx_projects = /** @type {(inputs: Mk_Mx_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyek, sub-issue, dependensi`)
};

/**
* | output |
* | --- |
* | "Projects, sub-issues, dependencies" |
*
* @param {Mk_Mx_ProjectsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_projects = /** @type {((inputs?: Mk_Mx_ProjectsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_ProjectsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_projects(inputs)
	return en_mk_mx_projects(inputs)
});